import LoadingPage from "@components/Loader/LoadingPage";
import { NFTEventInfo } from "@models/event";
import { DEFAULT_LANGUAGE, Language } from "@models/language";
import { useUserStore } from "@providers/auth";
import { getEventByIdOrSlug } from "@providers/checkout";
import { useQuery } from "@tanstack/react-query";
import EventDetail from "components/EventDetail/EventDetail";
import Header from "components/Header/Header";
import TicketingLayout from "components/TicketingLayout/TicketingLayout";
import type { NextPage } from "next";
import Head from "next/head";
import { useEffect, useMemo, useState } from "react";
import { LANDING_PAGE_URL, getServerSideEventId } from "utils/const";

const Event: NextPage<{ eventId: string }> = ({ eventId }) => {
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (!eventId) {
      window.location.href = LANDING_PAGE_URL;
      return;
    }
  }, [eventId]);

  const { data: event, isSuccess } = useQuery(
    [`event:${eventId}`],
    () => getEventByIdOrSlug(eventId),
    {
      enabled: !!eventId,
    }
  );

  const [language] = useState<Language>(DEFAULT_LANGUAGE);

  const info: NFTEventInfo = useMemo(() => {
    if (!event) return new NFTEventInfo({ name: "" });
    console.log(event);
    return event.localeInfo(language);
  }, [event, language]);

  useEffect(() => {
    if (!isSuccess) return;
    if (!event || !event.isPaid) {
      window.location.href = LANDING_PAGE_URL;
      return;
    }
  }, [event, isSuccess]);

  if (!event || !isSuccess) return <LoadingPage />;
  return (
    <>
      <Head>
        <title>{info.name || "Event"} | Moongate</title>
      </Head>
      <TicketingLayout header={<Header maxWidth={1024} />} footer={true}>
        <EventDetail user={user} event={event} />
      </TicketingLayout>
    </>
  );
};
export default Event;

export const getServerSideProps = getServerSideEventId;
